import { Checkbox, Text } from "@clipboard-health/ui-components";
import { FormControlLabel, Stack } from "@mui/material";
import { type Worker } from "@src/appV2/Worker/api/types";
import { type Control, Controller } from "react-hook-form";

import { useSelectedWorkType } from "../Onboarding/hooks/useSelectedWorkType";
import { type SignAgreementFormValues } from "./hooks/useICAgreementForm";

interface ICAgreementConfirmationCheckboxProps {
  worker: Worker;
  control: Control<SignAgreementFormValues>;
}

export function ICAgreementConfirmationCheckbox(props: ICAgreementConfirmationCheckboxProps) {
  const { worker, control } = props;
  const { isFlexAndPermanentPlacementsOnboarding } = useSelectedWorkType();

  return (
    <Controller
      name="confirmation"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={field.value}
              sx={{ alignSelf: "flex-start", marginRight: 2 }}
              onChange={(event) => {
                field.onChange(event.target.checked);
              }}
            />
          }
          label={
            <Stack spacing={2}>
              <Text variant="body2">
                By checking this box, you are signing this agreement electronically and agreeing to
                have your electronic signature in the name of <b>{worker.name}</b> added to the
                agreement.
              </Text>

              {isFlexAndPermanentPlacementsOnboarding && (
                <Text variant="body2">
                  These terms only apply to picking up shifts as an independent contractor. If you
                  are interviewing for jobs, you will be employed and paid by the facility.
                </Text>
              )}
            </Stack>
          }
        />
      )}
    />
  );
}
